import { AdyenCheckout, Dropin, Card, GooglePay, ApplePay } from "@adyen/adyen-web";
import { inject, observer } from "mobx-react";
import * as React from "react";
import { useRef, useEffect } from "react";
import { Spinner, Notice, Grid, GridColumn } from "telia-front-react";
import CardRedirect from "./CardRedirect.mjs";
import "@adyen/adyen-web/styles/adyen.css";
const DropInComponent = (props) => {
  const dropInRef = useRef(null);
  useEffect(() => {
    initializeCardPayment();
  }, []);
  useEffect(() => {
    mountDropIn();
  }, [props.cardStore.adyenPaymentMethodInputs?.payload, props.paymentStore.paymentAmount, props.reload]);
  const { translate } = props.translateStore;
  const { startPaymentErrorMessage, adyenPaymentMethodInputs } = props.cardStore;
  const cardManagerView = props.cardManagerStore?.cardManagerView;
  if (!adyenPaymentMethodInputs || adyenPaymentMethodInputs.isInitialLoading) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  if (adyenPaymentMethodInputs?.isFinishedWithError) {
    return /* @__PURE__ */ React.createElement(Notice, { type: "error", id: "payment-origin-key-missing-notice" }, translate("payment.card.origin-key-not-found-error"));
  }
  if (startPaymentErrorMessage) {
    return /* @__PURE__ */ React.createElement(Notice, { type: "error", id: "payment-status-error-notice" }, translate(startPaymentErrorMessage));
  }
  const { startPaymentLoadable } = props.cardStore;
  const { paymentStatus } = props.paymentStore;
  if (startPaymentLoadable?.isInitialLoading || paymentStatus === "IN_PROGRESS") {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  if (paymentStatus === "REDIRECT") {
    return /* @__PURE__ */ React.createElement(CardRedirect, { redirectFrameTarget: props.cardPayment.redirectFrameTarget });
  }
  const brandClass = props.brandStore.brand === "SUPER" ? "dropin-super" : "dropin-telia";
  const cardManagerClass = props.cardManagerStore?.cardManagerView ? " dropin-card-manager" : "";
  return /* @__PURE__ */ React.createElement(Grid, { align: ["center-xs"] }, /* @__PURE__ */ React.createElement(GridColumn, { width: cardManagerView ? ["xs"] : ["sm"] }, /* @__PURE__ */ React.createElement("div", { className: `dropin ${brandClass}${cardManagerClass}`, ref: dropInRef })));
  async function initializeCardPayment() {
    props.cardStore.setReloadAdyenPaymentMethodInputs(false);
    await props.cardStore.loadAdyenPaymentMethodInputs(props.shopperReference, props.source);
    if (!props.cardManagerStore.cardManagerView) {
      props.paymentStore.setPaymentStatus("NEW");
    }
  }
  async function mountDropIn() {
    if (props.cardStore.adyenPaymentMethodInputs?.payload) {
      if (!dropInRef.current) {
        return;
      }
      const adyenConfig = getAdyenConfig();
      const dropInCheckoutOptions = getDropInCheckoutOptions();
      const checkout = await AdyenCheckout(adyenConfig);
      const dropIn = new Dropin(checkout, dropInCheckoutOptions).mount(dropInRef.current);
      dropIn.update(dropInCheckoutOptions);
    }
  }
  function submitCardPaymentInput(state, _component, actions) {
    const { source, paymentOrderParams, referenceNumber, shopperReference, cardPayment } = props;
    const cardManagerView2 = props.cardManagerStore.cardManagerView;
    if (state.isValid) {
      const request = {
        amount: cardManagerView2 ? 0 : props.paymentStore.paymentAmount,
        referenceNumber,
        shopperReference,
        encryptedCardNumber: state.data.paymentMethod.encryptedCardNumber,
        encryptedMonth: state.data.paymentMethod.encryptedExpiryMonth,
        encryptedYear: state.data.paymentMethod.encryptedExpiryYear,
        encryptedSecurityCode: state.data.paymentMethod.encryptedSecurityCode,
        cardDetailsReference: state.data.paymentMethod.storedPaymentMethodId,
        googlePayToken: state.data.paymentMethod.googlePayToken,
        applePayToken: state.data.paymentMethod.applePayToken,
        source,
        returnUrl: cardPayment.returnUrl,
        brand: props.brandStore.brand,
        returnParams: cardPayment.cardReturnParams,
        paymentOrderParams,
        saveCardDetails: cardManagerView2 ? true : !!state.data.storePaymentMethod,
        cardManagerView: cardManagerView2,
        language: props.translateStore.currentLanguage
      };
      props.cardStore.startPaymentAndSetInterval(request, actions);
    }
  }
  function extractPaymentMethodConfiguration(paymentMethods, type) {
    const paymentMethod = paymentMethods?.find((it) => it.type === type);
    const paymentConfiguration = paymentMethod && paymentMethod.configuration;
    if (paymentConfiguration) {
      return {
        configuration: {
          gatewayMerchantId: paymentConfiguration["gatewayMerchantId"],
          merchantId: paymentConfiguration["merchantId"] || void 0,
          merchantName: paymentConfiguration["merchantName"] || void 0
        },
        buttonType: "plain",
        buttonColor: props.brandStore?.brand === "SUPER" ? "white" : "black"
      };
    }
    return {};
  }
  function getAdyenConfig() {
    const adyenPaymentMethodInputs2 = props.cardStore.adyenPaymentMethodInputs.payload;
    const locale = props.translateStore.getLocale();
    const cardManagerView2 = props.cardManagerStore.cardManagerView;
    return {
      locale,
      translations: props.translateStore.getTranslationsBasedOnLocale(cardManagerView2),
      environment: props.cardStore.getDropInEnvironment(),
      clientKey: adyenPaymentMethodInputs2.clientKey,
      paymentMethodsResponse: {
        ...adyenPaymentMethodInputs2.paymentMethodInputs,
        paymentMethods: adyenPaymentMethodInputs2.paymentMethodInputs.paymentMethods?.filter(
          (it) => !cardManagerView2 || !["applepay", "googlepay"].includes(it.type)
        )
      },
      amount: props.dropInAmount,
      countryCode: "EE",
      analytics: {
        enabled: false
      },
      onSubmit: submitCardPaymentInput,
      allowPaymentMethods: getAllowedPaymentMethods()
    };
  }
  function getAllowedPaymentMethods() {
    return ["APP_SELF_SERVICE", "SUPER_APP"].includes(props?.source) ? ["scheme"] : ["scheme", "googlepay", "applepay"];
  }
  function getDropInCheckoutOptions() {
    const adyenPaymentMethodInputs2 = props.cardStore.adyenPaymentMethodInputs.payload;
    const cardManagerView2 = props.cardManagerStore.cardManagerView;
    const paymentMethods = adyenPaymentMethodInputs2.paymentMethodInputs.paymentMethods;
    return {
      instantPaymentTypes: ["googlepay", "applepay"],
      showRemovePaymentMethodButton: true,
      paymentMethodComponents: [Card, GooglePay, ApplePay],
      paymentMethodsConfiguration: {
        card: {
          enableStoreDetails: props.showSaveCardButton,
          name: props.translateStore.translate(
            cardManagerView2 ? "payment.card-manager.card-name" : "payment.card.credit-or-debit-card"
          ),
          styles: getCardStyles()
        },
        applepay: extractPaymentMethodConfiguration(paymentMethods, "applepay"),
        googlepay: extractPaymentMethodConfiguration(paymentMethods, "googlepay"),
        storedCard: {
          styles: getCardStyles(),
          showPayButton: !cardManagerView2,
          hideCVC: cardManagerView2
        }
      },
      onDisableStoredPaymentMethod: async (storedPaymentMethodId, resolve, reject) => {
        await props.cardStore.deleteSavedCard(props.shopperReference, storedPaymentMethodId).then((response) => ["OK", "ALREADY_REMOVED"].includes(response) ? getResolve(resolve) : getReject(reject)).catch(() => getReject(reject));
      }
    };
  }
  function getResolve(resolve) {
    if (props.cardManagerStore.cardManagerView) {
      props.cardManagerStore.showCardDeleteSuccessNotice();
    }
    props.cardStore.setReloadAdyenPaymentMethodInputs(true);
    return resolve();
  }
  function getReject(reject) {
    if (props.cardManagerStore.cardManagerView) {
      props.cardManagerStore.showCardDeleteErrorNotice();
    }
    return reject();
  }
  function getCardStyles() {
    if (props.brandStore?.brand === "SUPER") {
      return {
        base: {
          color: "#ffffff",
          background: "#111111 !important"
          // to override Adyen's default background-clip attribute for secured fields
        },
        placeholder: {
          color: "#9a9a9a"
        },
        error: {
          color: "#EB3223"
        }
      };
    }
  }
};
const DropInComponent$1 = inject(
  "translateStore",
  "cardStore",
  "paymentStore",
  "brandStore",
  "cardManagerStore"
)(observer(DropInComponent));
export {
  DropInComponent$1 as default
};
